import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import { connect } from 'react-redux'
import 'react-tabs/style/react-tabs.css'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { bindActionCreators } from 'redux'

import BreadcrumbContainer from './../../../containers/BreadcrumbContainer'
import DataTableAdoptionsContainer from './../../../containers/DataTableContainers/Adoptions'
import PaginationContainer from './../../../containers/PaginationContainer'
import DatePicker from './../../../containers/DatePickerContainer'
import ModalSendBooksContainer from './../../../containers/ModalSendBooksContainer'
import FilterAdoptionsContainer from './../../../containers/FilterContainers/Adoptions'
import 'renanol-select/dist/react-select.css'
import AdoptionsMiddleware from '../../../modules/adoption/middleware'
import { setStatusOfSchoolAdoptions } from '../../../utils/utils'

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    fetchAdoptionsSend: (status, hasCurriculum) => AdoptionsMiddleware.fetchAdoptionsSend(status, hasCurriculum),
    resetFilter: () => AdoptionsMiddleware.resetFilter()
  }, dispatch)
}

const mapStateToProps = ({ auth, adoption }) => ({
  role: auth.userRole.role,
  adoptions: adoption.adoptions,
  triggerFetchAdoptionsToBeSent: adoption.triggerFetchAdoptionsToBeSent
})

class Adoption extends Component {
  componentDidMount () {
    this.props.resetFilter()
    this.props.fetchAdoptionsSend(setStatusOfSchoolAdoptions(this.props.role), true)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.triggerFetchAdoptionsToBeSent !== this.props.triggerFetchAdoptionsToBeSent) {
      this.props.fetchAdoptionsSend(setStatusOfSchoolAdoptions(this.props.role), true)
    }
  }

  render () {
    return (
      <div>
        <div className='container'>
          <div className='main-header'>
            <div className='main-header__column'>
              <BreadcrumbContainer />
              {this.props.role !== 'fractal_operator' &&
              <div>
                <label className='date-picker__field-label'>Prazo final</label>
                <DatePicker />
              </div>}
            </div>
          </div>
          
          <Tabs>
            <TabList>
              <Tab>Livros</Tab>
            </TabList>
            <TabPanel>
              {/* TODO: This should be implemented when the bug SPE-108 and SPE-109 is fixed. */}
              {/* {
                this.props.role !== 'fractal_operator' &&
                <div className='container'>
                  <div className='main-header' style={{ margin: '20px 0 10px' }}>
                    <div className='main-header__column'>
                      <TotalizersContainer />
                    </div>
                  </div>
                </div>
              } */}
              <div className='container'>
                <FilterAdoptionsContainer />
              </div> 
              <DataTableAdoptionsContainer />
              <PaginationContainer />
              <Route exact path='/adoption_send' component={ModalSendBooksContainer} />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Adoption)



// WEBPACK FOOTER //
// ./src/routes/Landing/Adoption/index.js